export const isExternal = () => (
  !!window.externalApp?.getExternalAuth ||
  !!window.webkit?.messageHandlers?.getExternalAuth)
